export default [
  {
    pageIndex: 1,
    solutions: [
      {
        id: 1,
        title: '机器视觉',
        description: '以AI+3D为核心，搭建新一代机器视觉智能编程环境，可视化、无代码的编程界面，一键仿真，实现产品标准化、全场景应用。视觉算法具有精度高、视野大，优异的抗环境光性能。',
        image: require('@/assets/img/solution/machine-vision.jpg'),
        link: '/solution/1',
        detailPath: '/solution/4'
      },
      {
        id: 2,
        title: '智能家居',
        description: ' 瑞谦智能家居解决方案秉承让人工智能创造美好生活的理念，瑞谦智能围绕智能照明、智能遮阳、智能安防、环境健康、背景音乐等系统，多方面满足客户的智能化需求，全方位打造智能、安全、舒适、人性化的家居生活体验。',
        image: require('@/assets/img/solution/smart-home.jpg'),
        link: '/solution/2',
        detailPath: '/solution/7'
      },
      {
        id: 3,
        title: '智慧园区',
        description: ' 瑞谦智慧园区解决方案以“以人为本，绿色高效，业务增值”的目标，利用物联网、大数据、人工智能等技术，搭建一体可视化综合管理平台，打破“信息孤岛”，实现人机事物深度融合互通，打造“安全、智慧、高效、绿色”的园区，满足政府管理部门、园区管理者、入驻企业、员工不同需求，大幅提升园区的管理和服务能力，提升园区的社会和经济价值。',
        image: require('@/assets/img/solution/smart-park.jpg'),
        link: '/solution/3',
        detailPath: '/solution/1'
      }
    ]
  },
  {
    pageIndex: 2,
    solutions: [
      {
        id: 4,
        title: '智慧校园',
        description: '瑞谦智慧校园解决方案以校园安全为核心，运用视频识别分析、物联网、大数据等技术，结合视频监控、校园出入口管理、周界安防等系统，构建具有丰富的报警联动功能的校园智慧安防，同时将学校教学、管理、生活等事务以及各类校园资源和应用系统高效整合，全面高效地对校园人、事、物进行统一管理，建设智慧化管理和智慧化服务的新型安全校园。',
        image: require('@/assets/img/solution/smart-campus.jpg'),
        link: '/solution/4',
        detailPath: '/solution/2'
      },
      {
        id: 5,
        title: '智慧社区',
        description: '瑞谦智慧社区解决方案以“互联网+”为基础，社区服务、智能家居为核心，围绕社区安全、生活娱乐、物业管理、医疗养老等需求，借助物联网、人工智能、大数据等新技术，把物业服务、安防管理、社区民生服务等集成在一个社区运营平台，打造一个统一服务入口建设“绿色、安全、舒适、便捷”的智慧社区，提高物业管理水平，提升业主生活品质。',
        image: require('@/assets/img/solution/smart-community.jpg'),
        link: '/solution/5',
        detailPath: '/solution/3'
      },
      {
        id: 6,
        title: '智慧公交',
        description: ' 瑞谦智慧公交解决方案是将智能机、公交车、站台与移动互联理念相融合的全新方案。通过公交智能化系统，管理者能准确定位每辆公交车所在的位置，了解运营中的车辆状况，科学地分配公交车数量或增减站点；乘客能实时了解车辆到站时间和载客数量，更合理地选择交通工具。同时，管理者可以通过站台及车辆信息发布媒介，实时准确地发布各类新闻、广告等信息。',
        image: require('@/assets/img/solution/smart-bus.jpg'),
        link: '/solution/8',
        detailPath: '/solution/8'
      }
    ]
  },
  {
    pageIndex: 3,
    solutions: [
      {
        id: 7,
        title: '智慧城管',
        description: '瑞谦智慧城管解决方案本着创新、协调、开放、共享的思路，运用信息化、智慧化、大数据等技术手段，通过科技创新带动理念创新、机制创新、监管创新、服务创新，推动城市管理向城市服务转变，提升城市管理能力和服务水平的现代化。 建设“两个中心”和“一套机制”的管理模式。',
        image: require('@/assets/img/solution/smart-city.jpg'),
        link: '/solution/7',
        detailPath: '/solution/6'
      },
      {
        id: 8,
        title: '智慧景区',
        description: '瑞谦智慧景区解决方案采用先进的物联网、云计算、大数据等技术，通过建立丰富的数字化基础设施和视频监控、人流监控、GIS地图等系统，打造统一管控平台，实现景区实时监测，提升拥堵聚集等事件的响应效率，使景区管理更加规范、科学、智慧，极大提高景区管理效率和景区服务能力。',
        image: require('@/assets/img/solution/smart-scenic.jpg'),
        link: '/solution/9',
        detailPath: '/solution/9'
      }
    ]
  }
]
